import {
    getFetching as getFetchingImport,
    getOutdated as getOutdatedImport,
    getAds as getAdsImport,
    getSteam as getSteamImport,
    getLanguage as getLanguageImport,
    getLocalizedAds as getLocalizedAdsImport,
    getLocalizedAdsForLocale as getLocalizedAdsForLocaleImport,
} from './feed/selectors'

const feed = {
    getFetching: state => getFetchingImport(state.feed),
    getOutdated: state => getOutdatedImport(state.feed),
    getAds: state => getAdsImport(state.feed),
    getSteam: state => getSteamImport(state.feed),
    getLanguage: state => getLanguageImport(state.feed),
    getLocalizedAds: state => getLocalizedAdsImport(state.feed),
    getLocalizedAdsForLocale: (state, locale) => getLocalizedAdsForLocaleImport(state.feed, locale),
}

// eslint-disable-next-line
export const selectors = { feed }



// WEBPACK FOOTER //
// ./src/features/Ads/data/selectors.js